import axiosInstance from "./axiosInstance";
import { BASE_URL } from "../constants/applicationConfig";

const BASE_URL_MEAL_TAGS = `${BASE_URL}/api/meal-tag`;

export class MealTagApi {
  static async fetchAll() {
    return (await axiosInstance.get(`${BASE_URL_MEAL_TAGS}`)).data;
  }

  static async create(mealTag) {
    return (await axiosInstance.post(`${BASE_URL_MEAL_TAGS}`, mealTag)).data;
  }

  static async deleteById(id) {
    return (await axiosInstance.delete(`${BASE_URL_MEAL_TAGS}/${id}`)).data;
  }
}
